import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/billing-automation'),
      component: SettingsWrapper,
      props: {
        headerTitle: 'BILLING_AUTOMATION.TITLE',
        icon: 'i-lucide-receipt',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'billing_automation_index',
          component: Index,
          meta: { permissions: ['administrator', 'account_manage'] },
        },
      ],
    },
  ],
};
